import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { UserManagementView } from '@/components/global-admin/UserManagementView';

export default function UserManagementPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">User Management</h2>
        <p className="text-muted-foreground">
          Manage system users, invite new users, and control super admin access
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Users</CardTitle>
          <CardDescription>
            View all users in the system, invite new users, and manage their permissions.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <UserManagementView />
        </CardContent>
      </Card>
    </div>
  );
}
